export default __webpack_public_path__ + "assets/gif.605d1d151a01356b376d5c4ac2f40d19.png";